export default "__VITE_ASSET__DLU9D9yZ__"